import * as types from './types';
import { uiActions } from 'state/modules/UI';
import * as commentsActions from 'services/api/comments';
import { getErrorMessage, parsePagination } from 'utils';

const fetchCommentsRequest = () => ({
  type: types.FETCH_COMMENTS_REQUEST,
});

const fetchCommentsSuccess = (payload) => ({
  type: types.FETCH_COMMENTS_SUCCESS,
  payload,
});

const fetchCommentsFailed = () => ({
  type: types.FETCH_COMMENTS_FAILED,
});

export const fetchComments = (params) => {
  return async (dispatch) => {
    dispatch(fetchCommentsRequest());

    const response = await commentsActions.fetchComments(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchCommentsSuccess({
          pagination,
          data: response.data,
        })
      );
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchCommentsFailed());
  };
};

const fetchAddCommentRequest = () => ({
  type: types.FETCH_ADD_COMMENT_REQUEST,
});

const fetchAddCommentSuccess = (payload) => ({
  type: types.FETCH_ADD_COMMENT_SUCCESS,
  payload,
});

const fetchAddCommentFailed = () => ({
  type: types.FETCH_ADD_COMMENT_FAILED,
});

export const fetchAddComment = (payload, params) => {
  return async (dispatch) => {
    dispatch(fetchAddCommentRequest());

    const response = await commentsActions.fetchAddComment(payload);

    if (response.ok) {
      dispatch(fetchAddCommentSuccess());
      return dispatch(fetchComments(params));
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: getErrorMessage(response.data),
      })
    );
    dispatch(fetchAddCommentFailed());
  };
};
